import i18n from 'i18next'
import * as Yup from 'yup'
import { diaryResponseFields } from '../../../../common/response/diary'

export const getDiaryValidationSchema = () => {
    const errorMsg = i18n.t('validation.message')
    const errorDate = i18n.t('validation.date')

    return {
        [diaryResponseFields.AREA]: Yup.string().trim().required(`${errorMsg}`),
        intermediaryDiaryBuyer: Yup.array().of(
            Yup.object().shape({
                [diaryResponseFields.BUYER_SELLER.NAME]: Yup.string().trim().required(`${errorMsg}`),
            })
        ),
        intermediaryDiarySeller: Yup.array().of(
            Yup.object().shape({
                [diaryResponseFields.BUYER_SELLER.NAME]: Yup.string().trim().required(`${errorMsg}`),
            })
        ),
        [diaryResponseFields.PROPERTY_TYPE]: Yup.string().trim().required(`${errorMsg}`),
        propertyCadastralParcelNo: Yup.string()
            .nullable()
            .when('propertyRegistryParcelNo', {
                is: (value: string) => !value?.trim(),
                then: Yup.string().nullable().trim().required(`${errorMsg}`),
            }),
        [diaryResponseFields.PROPERTY_REGISTRY_INSERT]: Yup.string().trim().required(`${errorMsg}`),
        [diaryResponseFields.PROPERTY_CADASTRAL_MUNICIPALITY]: Yup.string().trim().required(`${errorMsg}`),

        [diaryResponseFields.PRICE]: Yup.string().trim().required(`${errorMsg}`),
        [diaryResponseFields.CONCLUSION_PLACE]: Yup.string().trim().required(`${errorMsg}`),
        [diaryResponseFields.CONCLUSION_DATE]: Yup.string().matches(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, `${errorDate}`),
        [diaryResponseFields.FINAL_PAYMENT_DATE]: Yup.string().matches(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, `${errorDate}`),
        [diaryResponseFields.INTERMEDIARY_DIARY_DATE]: Yup.string().matches(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, `${errorDate}`),
    }
}
